<template>
  <div class="users-list">
    <v-banner color="error" dark v-if="fetchAllUsersError">
      <v-icon slot="icon" color="white" size="36">mdi-wifi-strength-alert-outline</v-icon>
      {{ errorDisplay(fetchAllUsersError) }}
      <template v-slot:actions>
        <v-btn text color="dark" @click="fetchAll">Retry</v-btn>
      </template>
    </v-banner>
    <v-alert
      v-if="usersMissingLastName.length"
      type="warning"
      outlined
      class="ma-4 mb-0"
    >
      {{ usersMissingLastName.length }}
      {{ usersMissingLastName.length === 1 ? "user is" : "users are" }} missing a last name.
      The affected profiles are marked in the table and should be updated in Keycloak.
    </v-alert>
    <v-banner>
      <v-avatar slot="icon" size="40">
        <v-icon>info</v-icon>
      </v-avatar>
      <div class="title-1">Tips</div>
      <div v-if="displayInfo" class="caption">
        <span>On this page you can display all <strong>users</strong>. </span>
        <span>All users are display whatever their organization.</span>
      </div>
      <template v-slot:actions>
        <v-btn text color="dark" @click="displayInfo = !displayInfo">{{displayInfo ?'Hide':'Show'}}</v-btn>
      </template>
    </v-banner>
    <v-container>
      <UsersTable
        :headers="headers"
        :data="users ? users : []"
        :isLoading="fetchAllUsersLoading"
        v-on:refresh="refresh"
      />
    </v-container>
    <v-snackbar v-model="snackbar" top>
      {{ errorMessage }}
      <v-btn color="red" text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import mixin from "@/mixins";
import UsersTable from "@/components/Admin/Users/UsersTable";

export default {
  mixins: [mixin],
  components: {
    UsersTable
  },
  data() {
    return {
      snackbar: false,
      errorMessage: "",
      displayInfo: false,
      headers: [
        {
          text: "First Name",
          align: "start",
          filterable: true,
          value: "first_name",
          width: "20%"
        },
        {
          text: "Last Name",
          align: "start",
          filterable: true,
          value: "last_name",
          width: "20%"
        },
        {
          text: "Email",
          align: "start",
          filterable: true,
          value: "email",
          width: "30%"
        }
        // { text: "Actions", value: "actions", sortable: false, align: "right" }
      ]
    };
  },
  computed: {
    ...mapState({
      users: state => state.users.all,
      fetchAllUsersLoading: state => state.users.fetchAll.pending,
      fetchAllUsersError: state => state.users.fetchAll.error
    }),
    usersMissingLastName() {
      return (this.users || []).filter(
        user => !user.last_name || !user.last_name.trim()
      );
    }
  },
  methods: {
    ...mapActions("users", { fetchAll: "fetchAll" }),
    refresh() {
      this.fetchAll().catch(error => {
        this.snackbar = true;
        this.errorMessage = this.errorDisplay(error);
      });
    }
  },
  created() {
    this.refresh();
  }
};
</script>
